import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { MetricOption } from 'lumen/controllers/market/parity/parity-manager';
import type { IssueType } from 'lumen/models/parity-manager/issue';

interface ParityParityManagerMetricBlockSignature {
  Args: {
    metric: MetricOption;
    setSelectedMetric: (metricId: IssueType) => void;
  };
}

const ParityParityManagerMetricBlock = <template>
  <button
    class="fake-prism-button flex items-center justify-between
      {{if @metric.isSelected 'fake-prism-button--selected'}}"
    type="button"
    {{on "click" (fn @setSelectedMetric @metric.id)}}
  >
    <p class="text-300--regular truncate">{{@metric.metricTitle}}</p>
    {{#if @metric.isLoading}}
      <p class="loading-pulse"></p>
    {{else}}
      <PrismBadge @label={{@metric.amountIssues}} @type="info" />
    {{/if}}
  </button>
</template> satisfies TOC<ParityParityManagerMetricBlockSignature>;

export default ParityParityManagerMetricBlock;
